import { useQuery } from '@tanstack/react-query'
import { fetchElectionById } from '@/services/elections'
import {
  fetchNationalSummary,
  fetchElectionResults,
  fetchRegionResults,
  fetchDistrictResults,
  electionResultKeys,
} from '@/services/electionResults'

export function useElection(electionId: string | undefined) {
  const query = useQuery({
    queryKey: ['elections', 'id', electionId],
    queryFn: () => fetchElectionById(electionId!),
    enabled: !!electionId,
  })

  return {
    election: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}

export function useNationalSummary(electionId: string | undefined) {
  const query = useQuery({
    queryKey: electionResultKeys.summary(electionId!),
    queryFn: () => fetchNationalSummary(electionId!),
    enabled: !!electionId,
  })

  return {
    summary: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}

export function useAllElectionResults(electionId: string | undefined) {
  const query = useQuery({
    queryKey: electionResultKeys.byElection(electionId!),
    queryFn: () => fetchElectionResults(electionId!),
    enabled: !!electionId,
  })

  return {
    results: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}

export function useRegionElectionResults(electionId: string | undefined, regionId: string | undefined) {
  const query = useQuery({
    queryKey: electionResultKeys.byRegion(electionId!, regionId!),
    queryFn: () => fetchRegionResults(electionId!, regionId!),
    enabled: !!electionId && !!regionId,
  })

  return {
    results: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}

export function useDistrictElectionResults(electionId: string | undefined, districtId: string | undefined) {
  const query = useQuery({
    queryKey: electionResultKeys.byDistrict(electionId!, districtId!),
    queryFn: () => fetchDistrictResults(electionId!, districtId!),
    enabled: !!electionId && !!districtId,
  })

  return {
    results: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}
